module.exports = __webpack_public_path__ + "img/letter-spacing.63dd6f52.svg";